module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp2_6000.84cdf9aa.png";